
import md5 from 'js-md5'

// 不需要登录也能访问的页面
export function isNotNeedLoginPage(skipToken = false) {
	if (
		localStorage.getItem('routerName') === 'login' ||
		location.pathname === '/regist-real' ||
		location.pathname === '/ib-application' ||
		location.pathname === '/regist-fail' ||
		location.pathname === '/regist-success' ||
		location.pathname === '/checkRegist' ||
		location.pathname === '/regist-simulate' ||
		location.pathname === '/forget-pwd' ||
		location.pathname === '/kyc' ||
		location.pathname === '/invite-code' ||
		location.pathname === '/forget-pwd' ||
		location.pathname === '/quick-pay-bind' ||
		location.pathname === '/quick-pay-unbind' ||
		location.pathname === '/security-auth' ||
		location.pathname === '/online-service' ||
		location.pathname === '/' ||
		location.pathname === '/privacy-policy' ||
		location.pathname === '/terms-of-service' ||
		(!skipToken && sessionStorage.getItem('assetQuery.token'))
	) {
		return true
	}
	return false
}

// 登录超时判断
export function loginTimeOutNotify(Bus, direct) {
	if (window.isThirdAuthTokenLogin) {
		localStorage.setItem('clickLastTime', new Date().getTime())
	}
	if (isNotNeedLoginPage(window.isThirdAuthTokenLogin)) {
		localStorage.setItem('clickLastTime', new Date().getTime())
		window.isThirdAuthTokenLogin = false
		return
	}
	let showDialog = false
	if (direct) {
		// 移动端不需要点击才弹出登录超时提示 直接弹出
		showDialog = true
		// let lastTime = localStorage.getItem('clickLastTime')
		// if (lastTime) {
		// 	showDialog = true
		// }
	} else {
		// 超时时间，默认30分钟
		let timeout = localStorage.getItem('loginLimitTime')
				? Number(localStorage.getItem('loginLimitTime')) * 60 * 1000
				: 30 * 60 * 1000,
			lastTime = localStorage.getItem('clickLastTime')
		if (lastTime && new Date().getTime() - lastTime > timeout) {
			showDialog = true

		} else {
			localStorage.setItem('clickLastTime', new Date().getTime()) // 每次点击更新点击时间
		}
	}
	if (showDialog) {
		// 判断上次最后一次点击的时间和这次点击的时间间隔是否大于30分钟
	  window.isneedlogin = false
		localStorage.removeItem('noticeFlag')
		localStorage.removeItem('openAccountTips')
		localStorage.removeItem('loginLimitTime')
		localStorage.removeItem('clickLastTime')
		showDialog = false
		// 不再弹出弹窗，直接退至登录页
		Bus.$VueCookies.remove('SESSION')
		localStorage.removeItem('accessToken')
		localStorage.setItem('clickLastTime', new Date().getTime())
		location.href = '/'
		// Bus.$emit('btnMessage', {
		// 	isdialog: true,
		// 	status: 'f', //操作成功 s,失败 f
		// 	msg: i18n.t('login.Loginout'),
		// 	fun_funtion: () => {
		// 		Bus.$VueCookies.remove('SESSION')
		// 		localStorage.removeItem('accessToken')
		// 		localStorage.setItem('clickLastTime', new Date().getTime())
		// 		location.href = '/'
		// 	}, //传点击去设置的方法
		// 	noOff: 0, //取消按钮
		// 	btnName: i18n.t('login.goLogin')
		// })
	}
}

export function isMobile() {
	return (
		/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
			navigator.userAgent
		) || window.innerWidth < 768
	)
}

// 订阅登录超时事件
export function subscribeLoginTimeOut(Bus) {
		// 移动端不需要监听登录超时事件
	if (!isMobile()) {
		// 监听页面是否超时未点击，退至登录
		document
		.getElementsByTagName('body')[0]
		.addEventListener('click', function () {
			loginTimeOutNotify(Bus, false)
		})
	} 
	window.addEventListener('LoginTimeOut', () => {
			loginTimeOutNotify(Bus, true)
		})
}

// 全局事件订阅
export function subscribeGlobalEvent(Bus, i18n) {
	window.addEventListener('ShowNoPermission', () => {
		Bus.$alert(
			i18n.t('index.withoutPermission.content'),
			i18n.t('index.withoutPermission.title')
		).finally(() => {
			location.href = '/'
		})
	})

	window.addEventListener('ShowErrorMessage', ev => {
		Bus.$message({ message: ev.msg.text, type: ev.msg.type, duration: 2000 })
	})
}

// 创建账号跳转, 1是真实账号 2.是模拟账号
export function createMtAccount(type, $router, kycAuthVerify) {
	if (type == 1) {
		if (!kycAuthVerify(4)) return
		$router.push({ path: '/addRealAccount', query: { type: type } })
	} else {
		if (!kycAuthVerify(3)) return
		$router.push({ path: '/addFiktivAccount', query: { type: type } })
	}
}

// 第三方登录header
export function getThirdPartLoginHeader() {
	return sessionStorage.getItem('assetQuery.sign')
		? {
				server: sessionStorage.getItem('assetQuery.server'),
				login: sessionStorage.getItem('assetQuery.login'),
				sign: sessionStorage.getItem('assetQuery.sign')
		  }
		: {}
}

// 初始化第三方登录
export function setupThirdPartLogin() {
	window.assetQuery.login = window.getQueryVariable('login')
	window.assetQuery.server = window.getQueryVariable('server')
	if (window.assetQuery.login) {
		sessionStorage.setItem('assetQuery.login', window.assetQuery.login)
	}
	if (window.assetQuery.server) {
		sessionStorage.setItem('assetQuery.server', window.assetQuery.server)
	}
	if (window.assetQuery.login && window.assetQuery.server) {
		window.assetQuery.sign = md5(
			window.assetQuery.login + window.assetQuery.server
		)
		sessionStorage.setItem('assetQuery.sign', window.assetQuery.sign)
	}
}
// 获取登录token
export function getAccessToken() {
	return (
		// 第三方登录传递过来的token
		sessionStorage.getItem('assetQuery.token') ||
		// 本地登录获取的授权token
		localStorage.getItem('accessToken') ||
		''
	)
}